module.exports = __webpack_public_path__ + "ZsSlovanka.jpg?396d58c37e96ec193c21a58d7b9ea7bb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/reference/ZsSlovanka.jpg
// module id = 68
// module chunks = 0